import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  considerTimePeriods,
  considerTimePeriodsForUnifiedMenu,
} from '../../../reducers/menuSlice';
import { selectCartModality } from '../../../selectors/cart';
import {
  selectActiveRestaurantTimezone,
  selectedStageSelector,
} from '../../../selectors/restaurant';
import { TIME_PERIOD_CHECK_INTERVAL } from '../../../utils/constants';
import { getMenuUnificationFeatureFlag } from '../../../utils/session-storage';

/**
 * Polls the clock to roll the menu over between day-parts (breakfast/lunch/…).
 * Extracted from MainPageLayout — a pure side effect that happened to live in
 * the layout root; it owns no layout concern of its own.
 */
const useMenuTimePeriodRollover = () => {
  const dispatch = useAppDispatch();
  const timezone = useAppSelector(selectActiveRestaurantTimezone);
  const stage = useAppSelector(selectedStageSelector);
  const modality = useAppSelector(selectCartModality);

  useEffect(() => {
    if (timezone) {
      const timer = setInterval(() => {
        if (getMenuUnificationFeatureFlag()) {
          dispatch(considerTimePeriodsForUnifiedMenu({ timezone }));
        } else {
          dispatch(considerTimePeriods({ modality, timezone, stage }));
        }
      }, TIME_PERIOD_CHECK_INTERVAL);
      return () => {
        clearInterval(timer);
      };
    }
  }, [timezone, dispatch, modality, stage]);
};

export default useMenuTimePeriodRollover;
